import * as common from '../common/Common';
import { appService } from '../common/AppService';
import { UserViewModel } from './UserToolbarViewModel';
import { SignInViewModel } from './SignInViewModel';
import { SignUpViewModel } from './SignUpViewModel';
import { UserProfileViewModel } from './UserProfileViewModel';

export class ShellViewModel {
    public appService = appService;
    public isMobile = false;
    public isHelp=false;
    public isLoading = true;
    public loadingSource = 'TypeFast';
    public userToolbar = new UserViewModel();
    public uiLocation = 'loading';
    public signIn = new SignInViewModel();
    public signUp = new SignUpViewModel();
    public userProfile = new UserProfileViewModel();
    public isUserSignedIn = false;
    public showSystemMessage = false;
    public systemMessage = '';

    public initialize() {
        this.uiLocation = appService.uiLocation;

        appService.newMessageAdded.listen((value) => {
            this.showSystemMessage = !!value;
            this.systemMessage = value;
        });

        appService.locationChanged.listen(() => {
            this.uiLocation = appService.uiLocation;

            this.isUserSignedIn = !!this.appService.userModel;

            if (this.uiLocation == 'home' && this.appService.userModel) {
                // show home.
            }
        });

        this.isMobile = window.location.search.indexOf('mobile') != -1;
        this.isHelp = window.location.search.indexOf('help') != -1;

        if (!this.isMobile) {
            var authToken = common.getCookie('authtoken');
            if (authToken) {
                common.callHttp('POST', 'user/signin/' + authToken).then((data) => {
                    Promise.all([appService.getUserModel()]).then(() => {
                        this.isLoading = false;
                        this.isUserSignedIn = true;
                        appService.requestDeviceToken();
                        appService.navigateTo('home');
                    }, error => {
                        this.isLoading = false;
                        appService.navigateTo('home');
                    });
                }, error => {
                    common.removeCookie('authtoken');
                    appService.navigateTo('home');
                });
            } else {
                this.isLoading = false;
                appService.navigateTo('home');
            }
        } else {
            this.isLoading=false;
        }
    };

    public goHome() {
        appService.navigateTo('home');
    }
}
